import { Auth } from "aws-amplify";

const defaultPermissions = {
  isAdministrator: false,
  isTeacher: false,
  isParent: false,
  isAssistant: false,
  canDeleteStudents: false,
  canEditReports: false,
  canSendReports: false,
  canEditStudents: false,
  canAddUsers: false,
};

const groupPermissions = {
  Administrators: {
    isAdministrator: true,
    canDeleteStudents: true,
    canEditReports: false,
    canEditStudents: true,
    canAddUsers: true,
  },
  Assistants: {
    isAssistant: true,
    canDeleteStudents: false,
    canEditReports: true,
    canEditStudents: false,
  },
  Teachers: {
    isTeacher: true,
    canDeleteStudents: true,
    canEditReports: true,
    canSendReports: true,
    canEditStudents: true,
    canAddUsers: true,
  },
  Parents: {
    isParent: true,
    canDeleteStudents: false,
    canEditReports: false,
    canEditStudents: false,
  },
};

export default class AppUser {
  role;
  tier;
  isAdministrator = false;
  isTeacher = false;
  isParent = false;
  isAssistant = false;
  canDeleteStudents = false;
  canEditReports = false;
  canSendReports = false;
  canEditStudents = false;
  canAddUsers = false;
  onAttributesChange = () => {};
  #cognitoUser;
  #isPro;

  constructor(cognitoUser) {
    this.#cognitoUser = cognitoUser;
    console.log(cognitoUser);
    this.role =
      this.#cognitoUser.signInUserSession.accessToken.payload[
        "cognito:groups"
      ][0];
    const userPermissions = Object.assign(
      {},
      defaultPermissions,
      groupPermissions[this.role],
    );
    for (const key in userPermissions) {
      this[key] = userPermissions[key];
    }
  }

  get id() {
    return this.#cognitoUser.attributes.sub;
  }

  // The id that owns this user's data (students, fields, announcements, etc).
  // Normally equal to `sub`, but diverges from it for accounts that went through
  // a Cognito email change, where `custom:user_id` points at the original record.
  get canonicalId() {
    const attrs = this.#cognitoUser.attributes;
    return attrs["custom:user_id"] || attrs.sub;
  }

  getAttributes = () => {
    return this.#cognitoUser.attributes;
  };

  isPro = () => {
    if (!this.isTeacher) {
      return false;
    }
    return this.#cognitoUser.attributes.isProUser;
  };

  setAttributes = async (attrs) => {
    this.#cognitoUser.attributes = {
      ...this.#cognitoUser.attributes,
      ...attrs,
    };
    console.log("new attrs", this.#cognitoUser.attributes);
    this.onAttributesChange(this.#cognitoUser.attributes);
  };

  updatePassword = async (currentPassword, newPassword) => {
    const result = await Auth.changePassword(
      this.#cognitoUser,
      currentPassword,
      newPassword,
    );
    return result;
  };
}
